import FeedbackCard from './FeedbackCard';
export default FeedbackCard;